import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Alert } from 'react-bootstrap';
import { forEach as _forEach } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { getDocSize, docIcons } from 'helpers/docs';

import IntlDate from 'components/layout/IntlDate';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import RichEditorContent from 'components/RichEditorContent';
import DataId from 'components/DataId';

import { Viewer } from 'components/viewer';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineDocUploaded extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      showFileViewer: false,
    };
  }

  showDetails = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showDetails: true });
  };

  showDoc = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      showFileViewer: true,
    });
  };

  closeFileViewer = () => {
    this.setState({ showFileViewer: false });
  };

  getDocDetails = () => {
    const { docDetails } = this.props;
    const docId = this.getParam('docId');
    return docDetails[docId] ? docDetails[docId] : { pending: true };
  };

  getViewerDocFiles = () => {
    const docDetails = this.getDocDetails();
    const res = [];

    if (!docDetails.pending) {
      _forEach(docDetails.data.files, (file, i) => {
        res.push({
          ...file,
          id: docDetails.data.id, // we need the document id, not the file id. we access the file through the page number
          getId: () => {
            return docDetails.data.id;
          },
          page: i,
        });
      });
    }

    return res;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      event,
    } = this.props;
    const { showDetails } = this.state;

    const docDetails = this.getDocDetails();

    return (
      <div className="card-block">
        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        {event && event.getDynParams() && event.getDynParams().length ? (
          <div className="p-t-10">
            {showDetails ? (
              <div>
                <DataId
                  dataIdName="doc"
                  dataIdId={this.getParam('docId')}
                  url={'/api/documents/' + this.getParam('docId') + '.json'}
                />

                {docDetails.pending ? (
                  <div>
                    <i className="fas fa-circle-notch fa-spin" />
                  </div>
                ) : (
                  <div>
                    <p>{messages.infos}</p>
                    <dl>
                      <dt>{messages.file}</dt>
                      <dd>
                        {docIcons(docDetails.data)} {docDetails.data.files[0].file_name}
                      </dd>

                      <dt className="m-t-5">{messages.type}</dt>
                      <dd>
                        <IntlFormInlineSelector /> {getNameInCurrentLanguage(docDetails.data.type.name, appIntl)}
                      </dd>

                      <dt className="m-t-5">{messages.file_size}</dt>
                      <dd>{getDocSize(docDetails.data)}</dd>

                      <dt className="m-t-5">{messages.file_extension}</dt>
                      <dd>{docDetails.data.files[0].extension}</dd>

                      <dt className="m-t-5">{messages.file_uploaded}</dt>
                      <dd>
                        <IntlDate date={docDetails.data.cdate} />
                      </dd>
                    </dl>

                    <p className="m-t-10">{messages.description}</p>
                    <RichEditorContent
                      content={'<div>' + (docDetails.data.description ? docDetails.data.description : '-') + '</div>'}
                    />

                    <div className="m-t-10">
                      <Button onClick={e => this.showDoc(e, this.state.shownIndex)}>
                        <i className="fa fa-eye" /> {messages.view}
                      </Button>
                    </div>

                    <Viewer
                      activeIndex={0}
                      show={this.state.showFileViewer}
                      close={this.closeFileViewer}
                      files={this.getViewerDocFiles()}
                    />
                  </div>
                )}
              </div>
            ) : (
              <a href="#details" onClick={this.showDetails}>
                <i className="fal fa-angle-double-right" /> {messages.show_details}
              </a>
            )}
          </div>
        ) : (
          <Alert>{messages.no_details_available}</Alert>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    docDetails: state.dataId.doc,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineDocUploaded));
